export const DEFAULT_EMOJI = {
  colons: ':bulb:',
  emoticons: [],
  id: 'bulb',
  name: 'Electric Light Bulb',
  native: '💡',
  short_names: ['bulb'],
  skin: null,
  unified: '1f4a1',
};
